import { useTranslation } from "react-i18next"
import { useFilters } from "../../contexts/FiltersContext"
import AsideFilterWrapper from "../aside-filter-wrapper"

const SimpleSelectFilter = ({ data, name, mapOptionRender }) => {
  const { t } = useTranslation("translations")
  const { filters, handleFilters } = useFilters()

  return (
    <AsideFilterWrapper title={t(`filters.${name}`)}>
      <select
        className={`mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md${
          filters?.[name]?.value ? " selected" : ""
        }`}
        defaultValue={filters?.[name]?.value ?? ""}
        onChange={({ target: { value } }) => {
          handleFilters(
            name,
            value === ""
              ? undefined
              : filters?.[name]?.value == value
              ? undefined
              : value
          )
        }}
      >
        <option value="">{t("filters.all_options")}</option>
        {data.map(mapOptionRender)}
      </select>
    </AsideFilterWrapper>
  )
}

export default SimpleSelectFilter
